import { Component, ElementRef, Inject, inject, Input, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { faDownload, faEdit, faTrash, faUsers, faUserSlash } from '@fortawesome/free-solid-svg-icons';
import { MatTableDataSource } from '@angular/material/table';
import { AssessmentService } from 'src/app/services/assessment.service';
import { UserService } from 'src/app/services/user.service';
import { FormBuilder } from '@angular/forms';
import { NewUserComponent } from '../../user/new-user/new-user.component';
import { DeleteUserComponent } from '../../user/delete-user/delete-user.component';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { map, Observable, of, startWith, Subject } from 'rxjs';
import { RemoveUserComponent } from '../../user/remove-user/remove-user.component';
import { DialogService } from 'src/app/services/dialog.service';
import { ExportUserComponent } from "../../user/export-user/export-user.component";
import { EditCertificationsComponent } from "../../user/edit-certifications/edit-certifications.component";
import { SkillsPipe } from 'src/pipes/skills.pipe';
import { UserSearchStateService } from 'src/app/services/userSearchState.service';

export enum AssignmentStatusEnum {
  AVAILABLE = 'Available',
  ON_ASSIGNMENT = 'OnAssignment',
  NOT_AVAILABLE = 'NotAvailable',
}

@Component({
  selector: 'app-user-roster',
  templateUrl: './user-roster.component.html',
  styleUrl: './user-roster.component.scss',
  standalone: false
})
export class UserRosterComponent implements OnInit, OnDestroy {
  faEdit = faEdit;
  faTrash = faTrash;
  faUsers = faUsers;
  faUserSlash = faUserSlash;
  faDownload = faDownload;

  @Input() role: string = "ALL_USERS"
  @Input() currentUser: any;
  //roster page type filter
  @Input() allow_delete: boolean = true;
  @Input() allow_remove: boolean = true;
  @Input() allow_export: boolean = false;
  //user type filter
  canEdit: any[] = [];
  canEditForest: any[] = [];
  canDelete: boolean = false;
  // forest / region filters
  @Input() filterForest: boolean = true;
  @Input() filterRegion: boolean = true;

  regions: any;
  selectedRegion: string = 'ANY';
  forest_names: any;
  agencies: any;
  skills: any;
  skillLevels: any;
  gitSkills: any;
  positions: any;
  user_count = 0;
  initial_user_count = 0;
  filtered_skills!: Observable<any[]>;
  filtered_read_skills!: Observable<any[]>;
  filtered_gis_skills!: Observable<any[]>;
  filtered_positions!: Observable<any[]>;
  selectedSkillFlag = false;
  selectedReadSkillFlag = false;
  selectedPositionFlag = false;
  @ViewChild('skills') inputSkill?: ElementRef<HTMLInputElement>;
  @ViewChild('positions') inputPosition?: ElementRef<HTMLInputElement>;
  @ViewChild('forest') input?: ElementRef<HTMLInputElement>;
  pageLoaded = false;
  filtered_forest_names!: Observable<string[]>;
  selectedForestFlag = false;

  searchForm = this.formBuilder.group({
    name: [""],
    region: [{ value: "All", disabled: false }],
    forest_name: [{ value: "", disabled: false }],
    agency: ["-1"],
    skill: ["" as any],
    read_skills: ["" as any],
    skill_level: ["-1"],
    gis_skill: ["-1"],
    position: ["" as any],
    available: ["" as AssignmentStatusEnum],
    available_level: ["" as any],
  });

  usersSource !: any;
  users = new MatTableDataSource<any>();
  displayedColumns!: string[];

  /*
  * Table variables
  * */
  pageNumber = 0;
  pageSize = 10;
  sort = "updated_on"
  sortDirection = "desc"
  filters: { [key: string]: any } = {
    full_name: null as (string | null | undefined),
    region: null as (string | null),
    forest_name: null as (string | null),
    agency_id: null as (number | null),
    skill_ids: null as (number | null),
    read_skills: null as (string | null),
    experience_ids: null as (number | null),
    assignment_status: null as (AssignmentStatusEnum | null),
    BAER_role_ids: null as (number | null),
    available_local: null as (boolean | null),
    available_nation: null as (boolean | null),
    available_region: null as (boolean | null)
  }
  filters_clean = true;

  AssignmentStatusEnum = AssignmentStatusEnum;

  userType: string = 'ALL';

  // Checkboxes
  selectAll: boolean = false;
  indeterminate = signal<boolean>(false);

  editTooltip: string = 'Edit';



  readSkillsMap: { [key: string]: string } = {
    archaeology_heritage_tribal: 'Archaeology/Heritage/Tribal',
    botany_invasives: 'Botany/Invasives',
    lead_read: 'Lead READ',
    roads_engineering: 'Roads/Engineering',
    suppression_repair: 'Suppression Repair',
    timber: 'Timber',
    trails_recreation: 'Trails/Recreation',
    watershed_fisheries_ais: 'Watershed/Fisheries/AIS',
    wilderness: 'Wilderness',
    wildlife: 'Wildlife',
  };

  constructor(
    public dialog: MatDialog,
    private readonly dialogService: DialogService,
    private readonly assessmentService: AssessmentService,
    private readonly userService: UserService,
    private readonly _snackBar: MatSnackBar,
    private readonly formBuilder: FormBuilder,
    private readonly skillsPipe: SkillsPipe,
    private readonly userSearchStateService: UserSearchStateService
  ) {
  }

  selectAllChange(showMessage: boolean = true) {
    this.indeterminate.set(false);
    if (this.selectAll) {
      this.users.data.forEach(datum => datum.isSelected = true);
      this.openSnackBar();
    } else {
      this.users.data.forEach(datum => datum.isSelected = false);
      this.closeSnackBar(showMessage);
    }
  }

  formatGisSkill(gisSkill: string) {
    return gisSkill.replace('_', ' ');
  }

  getPositions() {
    let positionsList = this.userService.getRoleList();
    switch (this.role) {
      case "COORDINATORS":
        this.positions = positionsList.filter((role: any) => role.type.endsWith("CO"));
        break;
      case "LINE_OFFICER":
        this.positions = positionsList.filter((role: any) => role.type.endsWith("LO"));
        break;
      default:
        this.positions = positionsList;
    }
  }

  private _filterSkills(value: any): any {
    if (value.text) value = value.text
    const filterValue = value.toLowerCase()
    return this.skills?.filter((option: any) => option.text.toLowerCase().includes(filterValue));
  }

  private _filterReadSkills(value: any): any {
    if (value.text) value = value.text
    const filterValue = value.toLowerCase()
    return Object.keys(this.readSkillsMap)
      .map(key => ({ value: key, text: this.readSkillsMap[key] }))
      .filter((option: any) => option.text.toLowerCase().includes(filterValue));
  }

  private _filterPositions(value: any): string[] {
    if (value.text) value = value.text
    const filterValue = value.toLowerCase()
    return this.positions?.filter((option: any) => option.text.toLowerCase().includes(filterValue))
  }

  baerSkillFilter(): void {
    const filterValue = this.inputSkill?.nativeElement.value.toLowerCase() ?? '';
    this.filtered_skills = of(this._filterSkills(filterValue));
  }

  readSkillFilter(): void {
    this.filtered_read_skills = of(this._filterReadSkills(''));
  }

  positionFilter(): void {
    const filterValue = this.inputPosition?.nativeElement.value.toLowerCase() ?? '';
    this.filtered_positions = of(this._filterPositions(filterValue));
  }

  clearSkillFilter(): void {
    if (!this.selectedSkillFlag) {
      this.searchForm.patchValue({
        skill: undefined,
      });
    }
    this.selectedSkillFlag = false
  }

  clearReadSkillFilter(): void {
    if (!this.selectedReadSkillFlag) {
      this.searchForm.patchValue({
        read_skills: undefined,
      });
    }
    this.selectedSkillFlag = false
  }

  clearPositionFilter(): void {
    if (!this.selectedPositionFlag) {
      this.searchForm.patchValue({
        position: "",
      });
    }
    this.selectedPositionFlag = false
  }

  getSkillName(option: any) {
    return option ? option?.text : "";
  }

  getReadSkillName(option: any) {
    return option ? option.text : "";
  }

  getPositionName(option: any) {
    return option ? option.text : "";
  }

  skillSelected() {
    this.selectedSkillFlag = true;
  }

  readSkillSelected() {
    this.selectedReadSkillFlag = true;
  }

  positionSelected() {
    this.selectedPositionFlag = true;
  }

  ngOnDestroy() {
    this._snackBar.dismiss();
  }

  ngOnInit(): void {
    this.regions = this.assessmentService.getRegionList();
    this.forest_names = this.assessmentService.getForestNameList();
    this.agencies = this.userService.getAgencyList();
    this.userService.getSkillList().subscribe(skillsList => {
      skillsList.forEach((skill: any) => { skill.text = this.skillsPipe.transform(skill.text) })
      this.skills = skillsList
    });
    this.skillLevels = this.userService.getExpList();
    this.gitSkills = ['NIS_BAER', 'VGIS'];

    this.filtered_skills = this.searchForm.controls["skill"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filterSkills((value as string) || ""))
    )
    this.filtered_read_skills = this.searchForm.controls["read_skills"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filterReadSkills((value as string) || ""))
    )
    this.filtered_positions = this.searchForm.controls["position"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filterPositions((value as string) || ""))
    )
    this.filtered_forest_names = this.searchForm.controls["forest_name"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filter((value as string) || ""))
    )

    this.getPositions();

    const savedFilters = this.userSearchStateService.get(this.role);
    if (savedFilters) {
      //load information with previous filters
      this.searchForm.patchValue(savedFilters)
      this.search();
    } else {
      //load information
      this.loadUsers();
    }

    this.setEditability();
  }

  setEditability() {
    if (this.role == "COORDINATORS" || this.role == "LINE_OFFICER") {
      this.displayedColumns = [
        //'select', only for canDelete
        'name',
        'region',
        'forest_name',
        'positions'
        //'actions' only for canDelete / canEdit
      ]
    } else {
      this.displayedColumns = [
        //'select', only for canDelete
        'name',
        'region',
        'forest_name',
        'agency',
        'skills',
        'assignment_status'
        //'actions' only for canDelete / canEdit
      ]
    }

    if (this.role === 'GIS') {
      this.editTooltip = 'Edit Users Certification';
      this.displayedColumns = [...this.displayedColumns, 'gis_skills'];
    }
    //setup editability for leader
    if (this.currentUser.isTeamLead?.length > 0 && this.role != "COORDINATORS") {
      this.canEdit = this.currentUser.isTeamLead;
      this.allow_delete = false;
      this.displayedColumns.unshift('select')
      if (!this.displayedColumns.includes('actions'))
        this.displayedColumns.push('actions')
    }
    //setup editability
    this.canEdit = this.currentUser.canEditRegion;
    this.canEditForest = this.currentUser.canEditForest;
    this.canDelete = this.currentUser.canDelete;
    if (this.canEdit.length > 0) {
      if (!this.displayedColumns.includes('select'))
        this.displayedColumns.unshift('select')
      if (!this.displayedColumns.includes('actions'))
        this.displayedColumns.push('actions');
    }
    if (this.canDelete && this.role !== 'GIS') {
      this.allow_delete = true;
    }
    //setup exportability
    if (this.currentUser.baer_roles?.some((role: { baer_role: { type: string; value: number; }; }) =>
      role.baer_role.type === 'WOCO'
      || role.baer_role.type === 'ROCO'
      || role.baer_role.value === 0
    ) || this.currentUser.isFOCO?.length > 0) {
      this.allow_export = true;
    }
  }

  sortChange(sortState: any) {
    this.sort = sortState.active;
    this.sortDirection = sortState.direction;
    this.pageNumber = 0;
    this.loadUsers();
  }

  loadUsers() {
    this.dialogService.openSpinner();
    this.userType = 'ALL';
    switch (this.role) {
      case "COORDINATORS":
        this.userType = 'CO';
        break;
      case "LINE_OFFICER":
        this.userType = 'LO';
        break;
      case "UNASSIGNED":
        this.userType = 'UNASSIGNED';
        break;
    }
    if (this.filterRegion) {
      this.searchForm.patchValue({
        region: this.currentUser.region,
      });
      this.filters['region'] = this.currentUser.region;
      this.filters_clean = false;
      this.filterRegion = false;
    }
    if (this.filterForest) {
      this.searchForm.patchValue({
        region: this.currentUser.region,
        forest_name: this.currentUser.forest_name,
      });
      this.searchForm.markAsDirty();
      this.filters['region'] = this.currentUser.region;
      this.filters['forest_name'] = this.currentUser.forest_name;
      this.filters_clean = false;
      this.filterForest = false;
    }
    if (Number(this.searchForm.value.gis_skill) !== -1) {
      this.filters[this.searchForm.value.gis_skill as any as string] = true;
    }
    this.userService.getUserList(this.userType, ["top_assigned_assessment", "skills", "agency", "baer_roles.baer_role"], this.pageNumber + 1, this.pageSize, this.filters, this.sort, this.sortDirection).subscribe({
      next: data => {
        let users = data.users
        this.setTooltip(users);
        this.users.data = users;
        this.usersSource = users;
        this.user_count = data.totalResults;
        this.initial_user_count = this.initial_user_count ? this.initial_user_count : data.totalResults;
        this.pageLoaded = true;
        this.dialogService.closeSpinner();
      },
      error: () => {
        this.pageLoaded = true;
        this.dialogService.closeSpinner();
      }
    });
  }

  pageEvent(e: any) {
    this.pageNumber = e.pageIndex;
    this.pageSize = e.pageSize;
    this.loadUsers();
  }

  search(): void {
    this.filters["region"] = this.searchForm.getRawValue().region == 'All' ? null : this.searchForm.getRawValue().region;
    this.filters["forest_name"] = (this.searchForm.getRawValue().forest_name ?? '') == '' ? null : this.searchForm.getRawValue().forest_name;
    this.filters["full_name"] = this.searchForm.value.name == '' ? null : this.searchForm.value.name?.trim().toLowerCase();
    this.filters["agency_id"] = this.searchForm.value.agency == '-1' ? null : Number(this.searchForm.value.agency);
    this.filters["experience_ids"] = this.searchForm.value.skill_level == '-1' ? null : Number(this.searchForm.value.skill_level);
    this.filters["skill_ids"] = this.searchForm.value.skill?.value == undefined ? null : Number(this.searchForm.value.skill.value);
    this.filters['BAER_role_ids'] = this.searchForm.value.position?.value == undefined ? null : Number(this.searchForm.value.position.value);
    this.filters['assignment_status'] = this.searchForm.value.available ? this.searchForm.value.available : null;

    this.filters['available_nation'] = null;
    this.filters['available_region'] = null;
    this.filters['available_local'] = null;
    if (this.searchForm.value.available_level == 'national') this.filters['available_nation'] = true;
    if (this.searchForm.value.available_level == 'regional') this.filters['available_region'] = true;
    if (this.searchForm.value.available_level == 'local') this.filters['available_local'] = true;

    if (this.searchForm.value.read_skills?.value != undefined) {
      this.filters[this.searchForm.value.read_skills.value] = true;
    }
    this.pageNumber = 0;
    this.filters_clean = false;
    this.userSearchStateService.set(this.role, this.searchForm.value);
    this.loadUsers();
  }

  setTooltip(users: any) {
    const skillMatched = (skill: { skill_id: number }, skill_id: number) => skill.skill_id === skill_id;
    users.forEach((user: any) => {
      /* Sort skills if necessary */
      if (this.searchForm.value.skill?.value != undefined) {
        user.skills.sort((a: any, b: any) => skillMatched(a, this.searchForm.value.skill.value) ? -1 : skillMatched(b, this.searchForm.value.skill.value) ? 1 : 0);
      }

      /* Set assessment tooltip*/
      let assessmentTooltip = '';
      if (user.top_assigned_assessment) {
        assessmentTooltip = 'Fire Assignment:\nFire name: ' + user.top_assigned_assessment.baer_name
        assessmentTooltip += '\nStart Date: ' + (user.top_assigned_assessment.tentative_start_week ? (new Date(user.top_assigned_assessment.tentative_start_week)).toLocaleDateString("en-US") : 'Please enter a date')
        assessmentTooltip += '\nClose Out: ' + (user.top_assigned_assessment.close_out_date ? (new Date(user.top_assigned_assessment.close_out_date)).toLocaleDateString("en-US") : 'Please enter a date')
      }
      user.assessmentTooltip = assessmentTooltip;

      /* Set skill tooltip */
      switch (this.role) {
        case "COORDINATORS":
          user.baer_roles = user.baer_roles?.filter((baer_role: any) => baer_role.baer_role.type?.substring(2) == 'CO')
          user.baer_roles.sort((a: any, b: any) => b.baer_role_id - a.baer_role_id)
          break;
        case "LINE_OFFICER":
          user.baer_roles = user.baer_roles?.filter((baer_role: any) => baer_role.baer_role.type?.substring(2) == 'LO')
          user.baer_roles.sort((a: any, b: any) => b.baer_role_id - a.baer_role_id)
          break;
      }
      let tooltip = '';
      let tooltip2 = '';
      for (let i = 1; user.skills.length - 1 >= i; i++) {
        tooltip += user.skills[i].skill.text + ' (' + user.skills[i].experience.text.replace(' assignments', "") + ')\n'
      }
      for (let i = 1; user.baer_roles.length - 1 >= i; i++) {
        tooltip2 += user.baer_roles[i].baer_role.text + '\n'
      }
      user.tooltip = tooltip;
      user.tooltip2 = tooltip2
    });
  }

  clearSearch() {
    this.searchForm.reset();
    this.searchForm.patchValue({
      name: "",
      region: "All",
      forest_name: undefined,
      agency: "-1",
      skill: "",
      position: "",
      skill_level: "-1",
      available_level: ""
    });
    Object.keys(this.filters)
      .forEach(filter => {
        (this.filters as any)[filter] = null;
      })
    this.searchRegionChanged('All');
    this.pageNumber = 0;
    this.userSearchStateService.set(this.role, null);
    this.filters_clean = true;
    this.loadUsers();
  }

  addNewUser(): void {
    let user_type = "User"
    switch (this.role) {
      case "COORDINATORS":
        user_type = "Coordinator";
        break;
      case "LINE_OFFICER":
        user_type = "Line Officer";
        break;
    }
    this.dialog.open(NewUserComponent, {
      width: "1000px",
      data: { 'user_type': user_type }, //User, Coordinator, Line Officer
      panelClass: ['animate__animated', 'animate__fadeInDown'],
    }).afterClosed().subscribe((reload) => {
      if (reload) {
        this.loadUsers();
      }
    })
  }

  editUser(user: any): void {
    let user_type = "User";
    let component: any = NewUserComponent;
    let width: string = '1000px';
    switch (this.role) {
      case "GIS":
        user_type = "Gis";
        component = EditCertificationsComponent;
        width = '600px';
        break;
      case "COORDINATORS":
        user_type = "Coordinator";
        break;
      case "LINE_OFFICER":
        user_type = "Line Officer";
        break;
    }
    this.dialog.open(component, {
      width,
      panelClass: ['animate__animated', 'animate__fadeInDown'],
      data: {
        user: user,
        user_type: user_type
      }
    }).afterClosed().subscribe((reload) => {
      if (reload) {
        this.loadUsers();
      }
    });
  }

  deleteUser(user: any): void {
    this.dialog.open(DeleteUserComponent, {
      width: "440px",
      panelClass: ['animate__animated', 'animate__fadeInDown'],
      data: {
        users: [user]
      }
    }).afterClosed().subscribe((reload) => {
      if (reload) {
        this.loadUsers();
        this.selectAll = false;
        this.selectAllChange(false);
      }
    })
  }

  removeUser(user: any): void {
    this.dialog.open(RemoveUserComponent, {
      width: "440px",
      panelClass: ['animate__animated', 'animate__fadeInDown'],
      data: {
        role: this.getTabRole(),
        users: [user]
      }
    }).afterClosed().subscribe((reload) => {
      if (reload) {
        this.loadUsers();
        this.selectAll = false;
        this.selectAllChange(false);
      }
    })
  }

  getTabRole() {
    let role: string | undefined = "BAER"
    switch (this.role) {
      case "COORDINATORS":
        role = "CO";
        break;
      case "LINE_OFFICER":
        role = "LO";
        break;
    }
    return role;
  }

  selectCheck() {
    this.closeSnackBar();
    const selectedUsers = this.users.data.filter(x => x.isSelected === true);
    if (selectedUsers.length === this.users.data?.length) {
      this.selectAll = true;
      this.indeterminate.set(false);
      this.openSnackBar();
    } else if (selectedUsers.length === 0) {
      this.selectAll = false;
      this.indeterminate.set(false);
    } else {
      this.indeterminate.set(true);
      this.openSnackBar();
    }
  }

  exportAllUsers() {
    this.openSnackBar(true);
  }

  closeSnackBar(showMessage: boolean = true) {
    if (!showMessage) {
      this._snackBar.dismiss();
      return;
    }
    this._snackBar.openFromComponent(DeleteUserSnackbarComponent, {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: 3000,
      data: {
        length: 0,
        allow_delete: this.allow_delete,
        allow_remove: this.allow_remove,
        allow_export: this.allow_export,
        canDelete: this.canDelete
      }
    });
  }

  openSnackBar(fetchAllUsers: boolean = false) {
    let selectedUsers = this.users.data.filter(x => x.isSelected === true);
    if (fetchAllUsers) {
      this.dialog.open(ExportUserComponent, {
        width: "783px",
        panelClass: ['animate__animated', 'animate__fadeInDown'],
        data: {
          fetchAllUsers,
          userCount: this.user_count,
          userType: this.userType,
          positions: this.positions,
          agencies: this.agencies,
          skills: this.skills,
          regions: this.regions,
          forests: this.forest_names,
          filters: this.filters
        }
      }).afterClosed().subscribe(() => {
        this.selectAll = false;
        this.selectAllChange(false);
      });
      return;
    }
    if (selectedUsers.length > 0) {
      let subject = new Subject()
      this._snackBar.openFromComponent(DeleteUserSnackbarComponent, {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        data: {
          length: selectedUsers.length,
          users: selectedUsers,
          subject: subject,
          allow_delete: this.allow_delete,
          allow_remove: this.allow_remove,
          allow_export: this.allow_export,
          canDelete: this.canDelete,
          role: this.getTabRole(),
          positions: this.positions,
          agencies: this.agencies,
          skills: this.skills,
          regions: this.regions,
          forests: this.forest_names,
          gis: this.role === 'GIS'
        }
      });
      subject.asObservable().subscribe(reload => {
        if (reload) {
          this.loadUsers();
        }
        this.selectAll = false;
        this.selectAllChange(false);
      })
    }
    else {
      this.closeSnackBar();
    }
  }

  clearValue(event: any) {
    event.target.value = ""
  }

  searchRegionChanged(value: any): void {
    this.searchForm.patchValue({ forest_name: undefined })
    if (value == 'All') this.forest_names = this.assessmentService.getForestNameList();
    else this.forest_names = this.assessmentService.getForestNameList(this.searchForm.value.region ?? undefined);
  }

  forestNameSelected(): void {
    this.selectedForestFlag = true;
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase()
    return this.forest_names.filter((option: string) =>
      option.toLowerCase().includes(filterValue)
    )
  }

  filter(): void {
    const filterValue = this.input?.nativeElement.value.toLowerCase() ?? '';
    this.filtered_forest_names = of(this._filter(filterValue));
  }

  clearForest() {
    if (!this.selectedForestFlag) {
      this.searchForm.patchValue({
        forest_name: undefined
      })
    }
    this.selectedForestFlag = false;
  }
}

@Component({
  selector: 'delete-user-snackbar',
  templateUrl: 'delete-user-snackbar.html',
  styleUrls: ['./delete-user-snackbar.component.scss'],
  standalone: false
})
export class DeleteUserSnackbarComponent {
  length = this.data.length;
  allow_delete = true;
  allow_remove = true;
  allow_export = true;
  canDelete = false;
  gis = false;

  faDownload = faDownload;
  faEdit = faEdit;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public dialog: MatDialog,
  ) {
    this.allow_delete = this.data.allow_delete;
    this.allow_remove = this.data.allow_remove;
    this.allow_export = this.data.allow_export;
    this.canDelete = this.data.canDelete;
    this.gis = this.data.gis;
  }
  snackBarRef = inject(MatSnackBarRef);

  exportUsers() {
    this.dialog.open(ExportUserComponent, {
      width: "783px",
      panelClass: ['animate__animated', 'animate__fadeInDown'],
      data: {
        users: this.data.users,
        positions: this.data.positions,
        agencies: this.data.agencies,
        skills: this.data.skills,
        regions: this.data.regions,
        forests: this.data.forests
      }
    }).afterClosed().subscribe((confirmed) => {
      this.data.subject.next(confirmed)
      this.clearList();
    })
  }

  deleteUsers() {
    this.dialog.open(DeleteUserComponent, {
      width: "440px",
      panelClass: ['animate__animated', 'animate__fadeInDown'],
      data: {
        users: this.data.users
      }
    }).afterClosed().subscribe((confirmed) => {
      this.data.subject.next(confirmed)
      this.clearList();
    })
  }

  removeUsers() {
    this.dialog.open(RemoveUserComponent, {
      width: "440px",
      panelClass: ['animate__animated', 'animate__fadeInDown'],
      data: {
        role: this.data.role,
        users: this.data.users
      }
    }).afterClosed().subscribe((confirmed) => {
      this.data.subject.next(confirmed)
      this.clearList();
    })
  }

  editCerts() {
    this.dialog.open(EditCertificationsComponent, {
      width: '600px',
      panelClass: ['animate__animated', 'animate__fadeInDown'],
      data: {
        user: this.data.users,
        user_type: "Gis"
      }
    }).afterClosed().subscribe((reload) => {
      this.data.subject.next(reload)
      this.clearList();
    });
  }

  clearList() {
    this.data.users?.forEach((user: any) => {
      user.isSelected = false;
    });
  }

}
